export const FETCH_ASSIGNMENTS_FOR_PINPOINT = 'Pinpoints/FETCH_ASSIGNMENTS_FOR_PINPOINT';
export const FETCH_ASSIGNMENTS_FOR_PINPOINT_SUCCESS = 'Pinpoints/FETCH_ASSIGNMENTS_FOR_PINPOINT_SUCCESS';
export const FETCH_ASSIGNMENTS_FOR_PINPOINT_FAILURE = 'Pinpoints/FETCH_ASSIGNMENTS_FOR_PINPOINT_FAILURE';

export const FETCH_PINPOINTS = 'Pinpoints/FETCH_PINPOINTS';
export const FETCH_PINPOINTS_SUCCESS = 'Pinpoints/FETCH_PINPOINTS_SUCCESS';
export const FETCH_PINPOINTS_FAILURE = 'Pinpoints/FETCH_PINPOINTS_FAILURE';

export const REMOVE_PINPOINT = 'Pinpoints/REMOVE_PINPOINT';
export const REMOVE_PINPOINT_SUCCESS = 'Pinpoints/REMOVE_PINPOINT_SUCCESS';
export const REMOVE_PINPOINT_FAILURE = 'Pinpoints/REMOVE_PINPOINT_FAILURE';

export const CLEAR_PINPOINT = 'Pinpoints/CLEAR_PINPOINT';
export const EMPTY_PINPOINTS = 'Pinpoints/EMPTY_PINPOINTS';
export const SET_PINPOINT = 'Pinpoints/SET_PINPOINT';
export const UPDATE_PINPOINTS = 'Pinpoints/UPDATE_PINPOINTS';
export const UPDATE_SEARCH_TERM = 'Pinpoints/UPDATE_SEARCH_TERM';



// WEBPACK FOOTER //
// ./src/containers/PinpointsPage/store/constants.js